import classNames from 'classnames';
import Modal from '../modal/modal';
import { getFormTemplatePrompt } from '@employ-engage/data';
import AiPromptChat from './ai-prompt-chat';
import { useTranslation } from 'react-i18next';

export interface AddTemplateFromAIModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSave?: (surveyTemplateId: string) => void;
}

export function AddTemplateFromAIModal({
  open,
  setOpen,
  onSave,
}: AddTemplateFromAIModalProps) {
  const { t } = useTranslation(['common']);
  const promptForUser = t('ai-prompt-for-user');
  const promptForAI = `${getFormTemplatePrompt.prompt}`;

  return (
    <Modal
      disableCloseOnOutsideClick
      open={open}
      setOpen={setOpen}
      panelClassName={classNames('w-full max-w-[1200px] relative')}
    >
      <div className="flex justify-between">
        <div className="text-2xl font-bold leading-9 text-gray-900">
          {t('Add Template Using AI')}
        </div>
        <button onClick={() => setOpen(false)}>
          <i className="fa fa-x cursor-pointer" />
        </button>
      </div>
      <div className="mt-5">
        <AiPromptChat
          setOpen={setOpen}
          promptForUser={promptForUser}
          promptForAI={promptForAI}
          onSave={onSave}
        />
      </div>
    </Modal>
  );
}

export default AddTemplateFromAIModal;
